import { useRef } from 'react';
import { useSaveWorkflowSteps } from 'assets/js/pages/engage/workflows/hooks/useSaveWorkflowSteps';
import { utilityNodeTypes } from 'assets/js/pages/engage/workflows/utils/constants';
import {
    actionsHaveFormDataSelector,
    useReactFlowStore,
} from 'assets/js/pages/engage/workflows/utils/store';

const useAutosaveNewNodes = () => {
    const nodeCountRef = useRef(0);
    const actionsHaveFormData = useReactFlowStore(actionsHaveFormDataSelector);
    const nodeCount = useReactFlowStore(
        state => state.nodes.filter(n => n.type && !utilityNodeTypes.includes(n.type)).length,
    );

    const { mutate: saveWorkflowSteps } = useSaveWorkflowSteps();

    if (nodeCount !== nodeCountRef.current && actionsHaveFormData) {
        if (nodeCount !== 0 && nodeCountRef.current > 0) {
            saveWorkflowSteps(undefined);
        }
        nodeCountRef.current = nodeCount;
    }
};

export { useAutosaveNewNodes };
